export const api = (vars) => {
  return fetch(process.env.PREACT_APP_GRAPHQL_API, {
    method: 'POST',
    body: JSON.stringify(vars)
  }).then(res => res.json())
}